/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionNote
 */
export interface InputUavMissionNote {
    /**
     * 
     * @type {string}
     * @memberof InputUavMissionNote
     */
    body: string;
}

/**
 * Check if a given object implements the InputUavMissionNote interface.
 */
export function instanceOfInputUavMissionNote(value: object): boolean {
    if (!('body' in value)) return false;
    return true;
}

export function InputUavMissionNoteFromJSON(json: any): InputUavMissionNote {
    return InputUavMissionNoteFromJSONTyped(json, false);
}

export function InputUavMissionNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionNote {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'],
    };
}

export function InputUavMissionNoteToJSON(value?: InputUavMissionNote | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'body': value['body'],
    };
}

